export default function getResource(label) {
    const resources = {
        shopNow: 'Magasiner',
        video: 'Vidéo'
    };

    return resources[label];
}
